// Main Top Banner with error handling
try {
  const slideshowElement = document.querySelector(".slideshow");
  if (slideshowElement) {
    const block_count = slideshowElement.getAttribute("aria-block-count");

    if (block_count !== null && block_count !== "1") {
      const itemsPerPage = block_count === "2" ? 2 : 3;
      const splide_maintop = new Splide(".slideshow", {
        autoplay: true,
        interval: 4000,
        rewind: true,
        perPage: itemsPerPage,
        gap: "16px",
        breakpoints: {
          1232: {
            autoplay: true,
            interval: 4000,
            rewind: true,
            perPage: 2,
            gap: "16px",
          },
          752: {
            autoplay: true,
            interval: 4000,
            rewind: true,
            perPage: 1,
            gap: "16px",
          },
        },
      });
      splide_maintop.mount();
    } else {
      const splide_maintop = new Splide(".slideshow", {
        autoplay: true,
        interval: 4000,
        rewind: true,
      });
      splide_maintop.mount();
    }
  } else {
    console.warn("Slideshow element not found");
  }
} catch (error) {
  console.warn("Failed to initialize main slideshow:", error);
}

// Secondary Slideshow (below featured categories) with error handling
let splide_secondary;

try {
  const slideshowSecondaryElement = document.querySelector(
    ".slideshow-secondary",
  );
  if (slideshowSecondaryElement) {
    const block_count_secondary =
      slideshowSecondaryElement.getAttribute("aria-block-count");

    const isBlockVersion =
      slideshowSecondaryElement.dataset.blockVersion === "true";

    if (
      isBlockVersion &&
      block_count_secondary !== null &&
      block_count_secondary !== "1"
    ) {
      // Mode blocks: perPage 2/3
      const itemsPerPage = block_count_secondary === "2" ? 2 : 3;
      splide_secondary = new Splide(".slideshow-secondary", {
        autoplay: true,
        interval: 4000,
        rewind: true,
        perPage: itemsPerPage,
        gap: "16px",
        breakpoints: {
          1232: {
            autoplay: true,
            interval: 4000,
            rewind: true,
            perPage: 2,
            gap: "16px",
          },
          752: {
            autoplay: true,
            interval: 4000,
            rewind: true,
            perPage: 1,
            gap: "16px",
          },
        },
      });

      splide_secondary.on("mounted resize", function () {
        const isOverflow =
          parseInt(block_count_secondary) > splide_secondary.options.perPage;
        splide_secondary.root.querySelector(
          ".splide__pagination",
        ).style.visibility = isOverflow ? "visible" : "hidden";
        splide_secondary.root.querySelector(
          ".splide__arrows",
        ).style.visibility = isOverflow ? "visible" : "hidden";
      });
    } else {
      // Mode classic: perPage 1
      splide_secondary = new Splide(".slideshow-secondary", {
        autoplay: true,
        interval: 4000,
        rewind: true,
      });
      splide_secondary.on("mounted", function () {
        const hasMultiple = parseInt(block_count_secondary) > 1;
        splide_secondary.root.querySelector(
          ".splide__pagination",
        ).style.visibility = hasMultiple ? "visible" : "hidden";
        splide_secondary.root.querySelector(
          ".splide__arrows",
        ).style.visibility = hasMultiple ? "visible" : "hidden";
      });
    }

    splide_secondary.mount();
  } else {
    console.warn("Secondary slideshow element not found");
  }
} catch (error) {
  console.warn("Failed to initialize secondary slideshow:", error);
}

// Tradeboxes Image Instance with error handling
try {
  const tradeBoxImage = document.querySelector(".tradebox.image");
  if (tradeBoxImage) {
    if (window.isDevice?.Mobile) {
      new Splide(".tradebox.image", {
        arrows: false,
        autoplay: true,
        interval: 4000,
        rewind: true,
      }).mount();
    } else {
      var splide_tradeboxes = new Splide(".tradebox.image", {
        focus: "center",
        perPage: 1,
        trimSpace: false,
        arrows: true,
        width: "82%",
        autoplay: true,
        interval: 4000,
        rewind: true,
      });
      splide_tradeboxes.mount();
    }
  }
} catch (error) {
  console.warn("Failed to initialize tradebox image slider:", error);
}

// TradeBoxes Products Instance with error handling
try {
  const tradeBoxProducts = document.querySelector(".tradebox.product");
  if (tradeBoxProducts) {
    if (window.isDevice?.Mobile) {
      new Splide(".tradebox.product", {
        arrows: false,
        autoplay: true,
        interval: 4000,
        rewind: true,
      }).mount();
    } else {
      var splide_tradeboxes = new Splide(".tradebox.product", {
        focus: "center",
        perPage: 1,
        trimSpace: false,
        arrows: true,
        width: "82%",
        autoplay: true,
        interval: 4000,
        rewind: true,
      });
      splide_tradeboxes.mount();
    }
  }
} catch (error) {
  console.warn("Failed to initialize tradebox product slider:", error);
}

// TradeBoxes Services Instance with error handling
try {
  const tradeBoxPosition2 = document.querySelector(".tradebox.services");
  if (tradeBoxPosition2) {
    if (window.isDevice?.Mobile) {
      new Splide(".tradebox.services", {
        arrows: false,
        autoplay: true,
        interval: 4000,
        rewind: true,
      }).mount();
    } else {
      var splide_tradeboxes = new Splide(".tradebox.services", {
        focus: "center",
        perPage: 1,
        trimSpace: false,
        arrows: true,
        width: "82%",
        autoplay: true,
        interval: 4000,
        rewind: true,
      });
      splide_tradeboxes.mount();
    }
  }
} catch (error) {
  console.warn("Failed to initialize tradebox services slider:", error);
}
